import { render } from "./UserManagementTab.vue?vue&type=template&id=5300cb1d"
import script from "./UserManagementTab.vue?vue&type=script&lang=js"
export * from "./UserManagementTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__